<router-outlet></router-outlet>
<ngx-ui-loader fgsColor="#ffd200" text="Cargando..." textColor="#ffd200"></ngx-ui-loader>